import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import { floor } from 'lodash';
import { TickerContainer, NumberContainer, Value, Label, SkeletonNumberContainer, } from './countdown.styles';
import { getLocalnVenueTime } from '~/utils/helpers';
const Countdown = ({ eventData }) => {
    const [countdownStatus, setCountdownStatus] = React.useState('pending');
    const [countdown, setCountdown] = React.useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    React.useEffect(() => {
        countdownClock();
    }, []);
    React.useEffect(() => {
        const interval = setInterval(() => {
            countdownClock();
        }, 1000);
        return () => clearInterval(interval);
    }, [eventData.start]);
    const countdownClock = () => {
        const dateWithZone = getLocalnVenueTime(eventData.start, eventData.venue.timezone_id);
        const diff = moment.duration(dateWithZone.userLocaltime.diff(moment()));
        setCountdown({
            days: floor(diff.asDays()),
            hours: diff.hours(),
            minutes: diff.minutes(),
            seconds: diff.seconds(),
        });
        if (diff.asSeconds() < 1) {
            setCountdownStatus('expired');
        }
        else if (countdownStatus === 'pending') {
            setCountdownStatus('active');
        }
    };
    if (countdownStatus === 'expired')
        return null;
    return (_jsx(TickerContainer, { id: "ticker", children: countdownStatus === 'active' ? (_jsx(_Fragment, { children: Object.entries(countdown).map(([k, v]) => (k !== 'days' || countdown.days > 0) && (_jsxs(NumberContainer, { children: [_jsx(Value, { children: v }), _jsx(Label, { children: k })] }, k + v))) })) : (Object.keys(countdown).map((key) => _jsx(SkeletonNumberContainer, {}, key))) }));
};
export default Countdown;
